import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SignedEditionDndaWorkflowStateView } from "./SignedEditionDndaWorkflowStateView";
import { SignedEditionDndaWorkflowStateViewStore } from "../../store/SignedEditionDndaWorkflowStateViewStore";
import { useStore } from "../../../../hooks";

export const SignedEditionDndaWorkflowStateViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/signedEditionDndaWorkflowState/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SignedEditionDndaWorkflowStateViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SignedEditionDndaWorkflowStateView
          signedEditionDndaWorkflowStateViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
